export default screenConfigFindTutor = {
  get: function(tutorMatching) {
    if (!(tutorMatching && tutorMatching.UiController)) return [];
    return [
      {
        id: 'subject',
        isInputScreen: true,
        inputScreen: {
          progress: '25%',
        },
        onLoad: function() {
          if (document.getElementById('selectedSubject') && document.getElementById('selectedSubject').value) {
            tutorMatching.UiController.navNext();
          }
        }
      },
      {
        id: 'level',
        isInputScreen: true,
        inputScreen: {
          progress: '50%',
        },
        background: 'hdr_girl_online_teaching.jpg',
      }, {
        id: 'intent',
        isInputScreen: true,
        inputScreen: {
          progress: '75%',
        },
      }, {
        id: 'timeslots',
        isInputScreen: true,
        inputScreen: {
          progress: "90%",
        },
      }, {
        id: 'loader',
        isInputScreen: false,
        onLoad: function() {
          setTimeout(function() {
            tutorMatching.UiController.fetchResult();
          }, 250);
        }
      },{
        id: 'stacked-cards-block',
        isInputScreen: false,
        onLoad: function() {
          document.querySelector('.tutor-matching-container  .stacked-cards-form').classList.add('d-flex');
          document.querySelector('.tutor-matching-container .stacked-cards-form').classList.remove('hidden');
          if (!$('.js-form-abtest').length) {
            window.stackedCards();
          } else {
            window.setHubspotData();
          }
        }
      }
    ]
  }
}